import { jsx as _jsx } from "react/jsx-runtime";
import { ListOutlinedIcon } from '@getgo/chameleon-icons/react';
import { EmptyState } from '@getgo/chameleon-web/react';
const NoItemsAvailable = ({ icon, title, body, actions }) => {
    return (_jsx(EmptyState, Object.assign({ icon: icon || _jsx(ListOutlinedIcon, {}, void 0), title: title, actions: actions }, { children: body }), void 0));
};
export default NoItemsAvailable;
//# sourceMappingURL=index.js.map